import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ERROR_ROUTE_SEGMENTS, isContentRoute } from '../constants/error-routes';

/** HTTP status codes that have a dedicated error page. */
const ERROR_PAGE_STATUSES = [400,401, 403, 404, 500,0] as const;

@Injectable({
  providedIn: 'root',
})
export class ChunkErrorHandlerService {
  private reloading = false;
  private router = inject(Router);

  /** Handles chunk load errors: clear caches and reload on first occurrence. No retries, no alert, no URL params. */
  handleChunkError(error: Error, chunkName?: string): void {
    
    const errorMessage = error.message || '';
    const errorName = error.name || '';
    const errorStack = (error as any).stack || '';

    const isChunkError =
      errorName === 'ChunkLoadError' ||
      (errorName !== 'TypeError' && (
        errorMessage.includes('Failed to fetch dynamically imported module') ||
        errorMessage.includes('Loading chunk') ||
        errorMessage.includes('chunk')
      )) ||
      errorMessage.includes('Failed to fetch dynamically imported module') ||
      errorMessage.includes('Loading chunk') ||
      errorMessage.includes('Loading CSS chunk') ||
      (errorMessage.includes('chunk') && (errorMessage.includes('fetch') || errorMessage.includes('load'))) ||
      errorMessage.includes('dynamically imported module') ||
      (error as any).type === 'chunkLoadError';

    if (!isChunkError || this.reloading) return;
    this.reloading = true;

    if ('caches' in window) {
      caches.keys().then(keys => keys.forEach(k => caches.delete(k))).catch(() => {});
    }
    if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
      navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister().catch(() => {})));
    }
    setTimeout(() => window.location.reload(), 10);
  }

  /**
   * Redirects to the error page for the given HTTP status (401, 403, 404, 500).
   * Skips redirect on content routes (pack, detail, search, gallery) so the page stays visible and can show errors inline.
   */
  handleHttpErrorByStatus(status: number): void {
    
    if (!ERROR_PAGE_STATUSES.includes(status as (typeof ERROR_PAGE_STATUSES)[number])) return;
    if (this.router.url.includes('/error/')) return;
    if (isContentRoute(this.router.url)) return; 

    const segments =
    status === 400
        ? ERROR_ROUTE_SEGMENTS.badrequest
      :status === 401
        ? ERROR_ROUTE_SEGMENTS.unauthorized
        : status === 403
          ? ERROR_ROUTE_SEGMENTS.accessdenied
          : status === 404
            ? ERROR_ROUTE_SEGMENTS.notFound
            : ERROR_ROUTE_SEGMENTS.serverError;
            
    this.router.navigate([...segments]);
  }
}
